/* @refresh reload */
declare module 'solid-js' {
  namespace JSX {
    interface DirectiveFunctions {
      validate: (ref: HTMLInputElement, accessor: () => any[]) => void;
    }
  }
}

declare global {
  const FlowbiteInstances: any;
}

// This is to handle lazy loaded coponentes when there is a new version of the app
window.addEventListener('vite:preloadError', () => {
  window.location.reload(); // refresh the page
});

// import posthog from 'posthog-js';
import * as Sentry from '@sentry/browser';

if (import.meta.env.MODE.includes('production')) {
  // posthog.init('phc_fWLtJ7iAe7gEFWOZxCzSuwq1ybvHlu8wygodql0hGwO', { api_host: 'https://us.i.posthog.com' });
  Sentry.init({
    dsn: 'https://d789a392d9c81608e3434df5d822a82f@o4507102798741504.ingest.us.sentry.io/4507102801428480',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/app\.accquant\.com\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.MODE,
  });
}

import { render } from 'solid-js/web';
import '@thisbeyond/solid-select/style.css';
import './index.css';
import App from './App';

const root = document.getElementById('root');

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    'Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?',
  );
}

root!.innerHTML = '';

render(() => <App />, root!);
